import React, { useState, useEffect, useRef } from "react";
import { styled } from "@mui/material/styles";
import { makeStyles, Button, Grid } from "@material-ui/core";
import Typography from "@mui/material/Typography";
import { Input } from "antd";

import {
  getAllZgfxLabel,
  addCategoryLabel,
  addFlow,
} from "../../actions/subscribe";
import LabelTree from "./LabelTree";
import { message } from "antd";

import closeSvg from "../../assets/svg/delete.svg";
import flowSvg from "../../assets/images/icon-flow.svg";

const useStyles = makeStyles({
  box: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "1440px",
    maxWidth: "90vw",
    background: "#fff",
    boxShadow: "0px 2px 8px 0px rgba(0, 0, 0, 0.2)",
    borderRadius: "4px",
  },
  title: {
    width: "100%",
    height: "50px",
    padding: "0 20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderBottom: "1px solid #e9e9e9",
    fontSize: "18px !important",
    color: "#333",
    boxSizing: "border-box",
    fontWeight: "bold !important",
    "& img": {
      cursor: "pointer",
      marginRight: "7px",
      marginTop: "-2px",
    },
  },
  infoBox: {
    width: "100%",
    padding: "20px 24px 8px",
    boxSizing: "border-box",
    background: "rgba(57, 192, 122, 0.06)",
    borderRadius: "12px 12px 12px 12px",
  },
  infoLine: {
    display: "flex",
    alignItems: "center",
    width: "100%",
  },
  fileTitle: {
    flex: 1,
    fontSize: "18px  !important",
    color: "#4a4a4a",
    fontWeight: "bold !important",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    cursor: "pointer",
  },
  btn: {
    width: "90px",
    height: "40px",
    borderRadius: "2px",
    background: "#0F25D1  !important",
    color: "#fff",
    fontSize: "14px",
    boxShadow: "none !important",
  },
  grayBtn: {
    width: "90px",
    height: "40px",
    marginLeft: "20px",
    borderRadius: "2px",
    border: "1px solid #d9d9d9",
    background: "#fff !important",
    color: "#0F25D1",
    fontSize: "14px",
    boxShadow: "none !important",
  },

  tag: {
    display: "inline-block",
    width: "38px",
    height: "38px",
    marginRight: "12px !important",
    background: (medical_file) => {
      if (medical_file.file_category == "指导原则") {
        return "#FF9E00";
      }
      if (medical_file.file_category == "法规") {
        return "#42BD57";
      }
      if (medical_file.file_category == "指导原则FDA") {
        return "#39C07A";
      }
      if (medical_file.file_category == "标准") {
        return "#64AAD6";
      }
      if (medical_file.file_category == "参考件") {
        return "#666666";
      }
      return "#5F6876";
    },
    borderRadius: "50%",
    color: "#fff",
    fontSize: "18px",
    fontWeight: "bold",
    textAlign: "center",
    lineHeight: "38px",
  },
  detailBox: {
    color: "#4a4a4a",
    fontSize: "14px",
    lineHeight: "20px",
    overflow: "hidden",
  },
  detailLine: {
    marginTop: "12px !important",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  labelLine: {
    display: "flex",
    marginTop: "12px !important",
  },
  labelBox: {
    flex: "1",
  },
  detail: {
    display: "inline-block",
    minWidth: "180px",
    marginRight: "20px !important",
    "& a": {
      color: "#0F55A4",
      cursor: "pointer",
      fontWeight: "bold",
    },
  },
  labelTag: {
    display: "inline-block",
    height: "28px",
    marginLeft: "13px",
    marginBottom: "12px",
    padding: "0 16px",
    fontSize: "14px",
    color: "#39C07A",
    lineHeight: "28px",
    background: "#fff",
    borderRadius: "4px",
  },
  treeBox: {
    marginTop: "26px",
    padding: "0 15px",
  },
  treeLine: {
    maxHeight: "235px",
    marginTop: "17px",
    display: "flex",
    flexWrap: "wrap",
    overflow: "auto",
  },
  treeTitle: {
    fontSize: "18px",
    color: "#666666",
    lineHeight: "21px",
    textStroke: "1px #666666",
  },
  modalBody: {
    padding: "12px 20px",
    maxHeight: "calc(99vh - 128px)",
    overflow: "auto",
  },
  footer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    height: "78px",
    padding: "0 27px",
    borderTop: "1px solid #e9e9e9",
  },
  textarea: {
    width: "100%",
    height: "100px !important",
    marginTop: "15px",
    padding: "10px 16px",
    fontSize: "14px",
    resize: "none",
    border: "1px solid #ccc",
    outline: "none",
  },
});
export default function FlowModal(props) {
  const { close, medical_file, filterName, isEdit, submitEdit } = props;
  const classes = useStyles(medical_file);
  const [checkids, setCheckids] = useState([]);
  const [labelList, setLabelList] = useState([]);
  const [treeData, setTreeData] = useState([]);
  const [checkedKeys, setCheckedKeys] = useState([]);
  const [note, setNote] = useState("");

  const getCheckedKey = (keys) => {
    let index = checkedKeys.findIndex((v) => {
      return v.title == keys.title;
    });
    let newKeys = [].concat(checkedKeys);
    if (index > -1) {
      newKeys[index] = keys;
    } else {
      newKeys.push(keys);
    }
    setCheckedKeys(newKeys);
  };

  const createLabel = (label, parentId, callback) => {
    addCategoryLabel({
      lable_content: label,
      lable_category_id: parentId,
    }).then((res) => {
      if (res.data) {
        getTreeData();
        callback();
      } else {
        message.error(res.msg);
      }
    });
  };

  const getTreeData = () => {
    getAllZgfxLabel({
      lable_category_type: "直观复兴",
    }).then((res) => {
      let checkIds = [];
      let result = res.results;
      if (filterName) {
        result = result.filter((v) => {
          return v.lable_category_name == filterName;
        });
      }
      let checkedIds = [];
      let data = result.map((v) => {
        let isGrayLabel = false;
        let list = []
        if (medical_file.lables && medical_file.lables.lable_info) {
          let labelObj = JSON.parse(medical_file.lables.lable_info)
          list = labelObj[filterName] || []
          setLabelList(list)
          v.lables.forEach((item) => {
            let index = list.indexOf(item.lable_content) > -1
            if (index > -1) {
              isGrayLabel = true;
              checkIds.push(item.id);
            }
          });
        }
        if (isEdit) {
          checkedIds.push({
            title: filterName,
            children: [],
          });
        }

        return [
          {
            key: v.id,
            disabled: isEdit ? false : isGrayLabel,
            title: v.lable_category_name,
            children: v.lables.map((val) => {
              let isGray = false;
              if (medical_file.lables && medical_file.lables.lable_info) {
                let i = list.findIndex((label) => {
                  return label == val.lable_content;
                });
                if (i > -1) {
                  checkIds.push(val.lable_id);
                  isGray = true;
                }
              }
              if (isGray && isEdit) {
                checkedIds[0].children.push(val.lable_content);
              }
              return {
                key: val.lable_id,
                title: val.lable_content,
                disabled: isEdit ? false : isGray,
              };
            }),
          },
        ];
      });
      setCheckedKeys(checkedIds);
      setCheckids(checkIds);
      setTreeData(data);
    });
  };

  useEffect(() => {
    getTreeData();
  }, []);

  const submit = () => {
    if (
      checkedKeys.length == 0 ||
      (checkedKeys[0] &&
        checkedKeys[0].children &&
        checkedKeys[0].children.length == 0)
    ) {
      message.warning("请勾选分类标签");
      return;
    }
    let labelInfo = {};
    let checkList = [];
    checkedKeys.forEach((v) => {
      labelInfo[v.title] = v.children;
      checkList = checkList.concat(v.children);
    });
    if (isEdit) {
      submitEdit(checkList);
    } else {
      addFlow({
        base_file_id: medical_file.base_file_id,
        is_gap_analyseis: "否",
        is_training_session: "否",
        lable_info: JSON.stringify(labelInfo),
        comments: note,
        is_evaluation_sheet_needed: "否",
      }).then((res) => {
        if (res.isOperateSuccess) {
          message.success("提交成功");
          close();
        } else {
          message.error(res.message);
        }
      });
    }
  };

  const changeNote = (e) => {
    let newNote = e.target.value;
    setNote(newNote);
  };

  return (
    <Grid className={classes.box}>
      <Typography className={classes.title}>
        <Typography variant="span">
          <img src={flowSvg} />
          {isEdit ? "标签分类修改" : "发起分类流程"}
        </Typography>
        <Typography variant="span" onClick={() => close()}>
          <img src={closeSvg} />
        </Typography>
      </Typography>

      <Grid className={classes.modalBody}>
        <Grid className={classes.infoBox}>
          <Grid className={classes.infoLine}>
            <Typography variant="span" className={classes.tag}>
              {medical_file.file_category.substring(0, 1)}
            </Typography>
            <Typography className={classes.fileTitle}>
              <span
                className={classes.fileType}
                title={medical_file.file_name}
              >
                {medical_file.file_name}
              </span>
            </Typography>
          </Grid>
          <Grid className={classes.detailBox}>
            <Typography className={classes.detailLine}>
              <Typography variant="span" className={classes.detail}>
                发布时间：
                {medical_file.medical_file_publish_date.substring(0, 10)}
              </Typography>
              {medical_file.medical_file_law_status == "征求意见稿" ? (
                <Typography variant="span" className={classes.detail}>
                  截止时间：
                  {medical_file.medical_file_expired_date ? medical_file.medical_file_expired_date.substring(0, 10) : ''}
                </Typography>
              ) : (
                medical_file.medical_file_force_date && (
                  medical_file.medical_file_force_date.substring(0, 10) !=
                    "1970-01-01" && (
                    <Typography variant="span" className={classes.detail}>
                      生效时间：
                      {medical_file.medical_file_force_date.substring(0, 10) }
                    </Typography>
                  )
                )
              )}
              <Typography variant="span" className={classes.detail}>
                发布机构：
                {medical_file.medical_file_publish_orgnization}
              </Typography>
            </Typography>

            <Typography className={classes.detailLine}>
              <Typography variant="span" className={classes.detail}>
                文件类型： {medical_file.file_category}
              </Typography>
              <Typography variant="span" className={classes.detail}>
                管辖区域： {medical_file.medical_file_admin_location}
              </Typography>
            </Typography>

            <Typography className={classes.labelLine}>
              <span>已有分类标签：</span>
              <div className={classes.labelBox}>
                {medical_file.lables && medical_file.lables.lable_info && 
                  labelList.map((v, i) => (
                    <span className={classes.labelTag} key={i}>
                      {v}
                    </span>
                  ))}
              </div>
            </Typography>
          </Grid>
        </Grid>

        <Grid className={classes.treeBox}>
          <Typography variant="span" className={classes.treeTitle}>
            选择分类标签
          </Typography>
          <Grid className={classes.treeLine}>
            {treeData.map((v, i) => (
              <LabelTree
                key={i}
                data={v}
                isEdit={isEdit}
                checkIds={checkids}
                createLabel={createLabel}
                getCheckedKey={getCheckedKey}
              ></LabelTree>
            ))}
          </Grid>
        </Grid>

        <Grid className={classes.treeBox}>
          <Typography variant="span" className={classes.treeTitle}>
            备注
          </Typography>
          <Input.TextArea
            className={classes.textarea}
            value={note}
            onChange={changeNote}
          />
        </Grid>
      </Grid>

      <Grid className={classes.footer}>
        <Button className={classes.btn} variant="contained" onClick={submit}>
          {isEdit ? "保存" : "提交"}
        </Button>
        <Button onClick={close} className={classes.grayBtn} variant="contained">
          取消
        </Button>
      </Grid>
    </Grid>
  );
}
